export const P00032PositionType = [
  { ref: 0, label: 'P00032.positiontype.0' },
  { ref: 1, label: 'P00032.positiontype.1' },
];
